module.exports = __webpack_public_path__ + "static/media/20180608_162525.3888852e.jpg";